import {BROWSER_SIZE_LEVEL} from '@/util/constant.js'

export function reactiveBrowserSize(callback) {
  window.onresize = callback
}

export function getBrowserSize() {
  if (window.innerWidth < 768) {
    return 'xs'
  } else if (window.innerWidth < 992) {
    return 'sm'
  } else if (window.innerWidth < 1200) {
    return 'md'
  } else if (window.innerWidth < 1920) {
    return 'lg'
  } else {
    return 'xl'
  }
}

export function getBrowserSizeLevel() {
  if (window.innerWidth < 768) {
    return BROWSER_SIZE_LEVEL.xs
  } else if (window.innerWidth < 992) {
    return BROWSER_SIZE_LEVEL.sm
  } else if (window.innerWidth < 1200) {
    return BROWSER_SIZE_LEVEL.md
  } else if (window.innerWidth < 1920) {
    return BROWSER_SIZE_LEVEL.lg
  } else {
    return BROWSER_SIZE_LEVEL.xl
  }
}
